import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import AuthService from "../../AuthService";
import { useConfirm } from "../../components/DialogConfirm";
import Template from "../Generico/Template";
import CadastroProduto from "./components/CadastroProduto.js";
import DialogSearchProducts from "./components/DialogSearchProducts";
import LinkMenu from "./components/LinkMenu";
import TitleMenu from "./components/TitleMenu";

const Cardapio = () => {
  const [grupos, setGrupos] = useState([]);
  const [ativos, setAtivos] = useState(true);
  const [identificadores, setIdentificadores] = useState([]);
  const [openBusca, setOpenBusca] = useState(false);
  const [produtosBuscados, setProdutosBuscados] = useState(null);
  const [subProdutosBuscados, setSubProdutosBuscados] = useState(false);
  const [escolhaBusca, setEscolhaBusca] = useState("PRODUTO");
  const confirm = useConfirm();
  const [produtoEdit, setProdutoEdit] = useState(null);
  const [openCadProd, setOpenCadProd] = useState(false);
  const [loading, setLoading] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    handleListIdentificadores();
    handleListGrupos();
    document.title = "QR Pedir - Cardapio";

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleListIdentificadores = () => {
    const service = new AuthService();
    service
      .get("/identificador/tipo/DELIVERY")
      .then(setIdentificadores)
      .catch(() =>
        enqueueSnackbar("Erro ao buscar loja online", { variant: "error" })
      );
  };

  const handleListGrupos = () => {
    const service = new AuthService();
    service
      .get("/grupoProduto/listTodosComProdutos")
      .then((resp) => {
        setGrupos(resp);
        handleListProdutosPromocao(resp);
      })
      .catch(() =>
        enqueueSnackbar("Erro ao buscar grupos", { variant: "error" })
      );
  };

  const handleListProdutosPromocao = (gruposAtuais) => {
    const service = new AuthService();
    const grupoProduto = {
      id: -1,
      ordem: -1,
      descricao: "Em promoção",
      ativo: true,
      pausado: false,
      tipoGrupoProduto: { id: 1 },
    };
    const grupoPojo = { grupoProduto, produtos: [] };

    service
      .get("/produto/listPromocaoCompact")
      .then((resp) => {
        grupoPojo.produtos = resp;
        const novosGrupos = [...gruposAtuais, grupoPojo].sort(
          (a, b) => a.grupoProduto.ordem - b.grupoProduto.ordem
        );
        setGrupos(novosGrupos);
      })
      .catch((err) =>
        enqueueSnackbar("Erro ao buscar grupos" + err, { variant: "error" })
      );
  };

  const handlePauseGrupo = (event, grupo) => {
    event.stopPropagation();
    const payload = {
      id: grupo.grupoProduto.id,
      pausado: !grupo.grupoProduto.pausado,
    };

    const service = new AuthService();
    service
      .put("/grupoProduto/changeOnly", payload)
      .then((retorno) => {
        grupo.grupoProduto = retorno;
        setGrupos([...grupos]);
        enqueueSnackbar("Grupo pausado/ativado com sucesso!", {
          variant: "success",
        });
      })
      .catch(console.error);
  };

  const handlePauseProduto = (event, produto, grupo = null) => {
    event.stopPropagation();
    let gruposAtualizados = [...grupos];

    if (!grupo) {
      gruposAtualizados.forEach((g) =>
        g.produtos.forEach((p) => {
          if (p.id === produto.id) grupo = g;
        })
      );
    }

    const payload = { id: produto.id, pausado: !produto.pausado };
    const service = new AuthService();

    service
      .put("/produto/changeOnly", payload)
      .then((retorno) => {
        if (produtosBuscados) {
          const index = produtosBuscados.findIndex(
            (el) => el.id === produto.id
          );
          produtosBuscados[index] = retorno;
          setProdutosBuscados([...produtosBuscados]);
        }

        const index = grupo.produtos.findIndex((el) => el.id === produto.id);
        grupo.produtos[index] = retorno;
        setGrupos([...gruposAtualizados]);
        enqueueSnackbar("Produto pausado/ativado com sucesso!", {
          variant: "success",
        });
      })
      .catch(console.error);
  };

  const handleUpdateGrupo = (groups) => setGrupos(groups);
  const handleChangeAtivos = () => setAtivos((prev) => !prev);
  const onCopy = () => enqueueSnackbar("Copiado", { variant: "success" });
  const handleChangeProduto = (produto, mudanca, grupoAntigo) => {
    let index = grupos.findIndex(
      (el) => el.grupoProduto.id === produto?.grupoProduto?.id
    );
    if (index === -1) return;
    let indexProd = grupos[index]?.produtos?.findIndex(
      (el) => el.id === produto.id
    );

    if (mudanca === "SALVAR") {
      if (produtosBuscados) {
        let indexBuscado = produtosBuscados.findIndex(
          (el) => el.id === produto.id
        );
        produtosBuscados[indexBuscado] = produto;
        setProdutosBuscados(produtosBuscados);
      }

      if (grupoAntigo && grupoAntigo.id !== produto.grupoProduto.id) {
        let indexGpAntigo = grupos.findIndex(
          (el) => el.grupoProduto.id === grupoAntigo.id
        );
        let indexProdGpAntigo = grupos[indexGpAntigo].produtos.findIndex(
          (el) => el.id === produto.id
        );
        grupos[indexGpAntigo].produtos.splice(indexProdGpAntigo, 1);
      }

      if (indexProd > -1) {
        grupos[index].produtos[indexProd] = produto;
      } else {
        grupos[index].produtos.push(produto);
      }
    } else if (mudanca === "EXCLUIR") {
      if (produtosBuscados) {
        let indexBuscado = produtosBuscados.findIndex(
          (el) => el.id === produto.id
        );
        produtosBuscados.splice(indexBuscado, 1);
        setProdutosBuscados(produtosBuscados);
      }
      if (indexProd > -1) {
        grupos[index].produtos.splice(indexProd, 1);
      }
    }

    let idxGrupoPromo = grupos.findIndex((el) => el.grupoProduto.id === -1);
    let idxProdPromo = grupos[idxGrupoPromo].produtos.findIndex(
      (prod) => prod.id === produto.id
    );

    if (mudanca === "SALVAR") {
      if (idxProdPromo >= 0) {
        if (produto.promocaoAtiva) {
          grupos[idxGrupoPromo].produtos[idxProdPromo] = produto;
        } else {
          grupos[idxGrupoPromo].produtos.splice(idxProdPromo, 1);
        }
      } else {
        if (produto.promocaoAtiva) {
          grupos[idxGrupoPromo].produtos.push(produto);
        }
      }
    } else if (mudanca === "EXCLUIR") {
      if (idxProdPromo >= 0) {
        grupos[idxGrupoPromo].produtos.splice(idxProdPromo, 1);
      }
    }

    handleUpdateGrupo(grupos);
  };
  const baixarQRCode = (identificador) => {
    const service = new AuthService();
    const urlTOQrcode = "http://" + identificador + ".qrpedir.com";

    service
      .download(
        "/identificador/gerarQrcode?url=" + encodeURIComponent(urlTOQrcode)
      )
      .then((retorno) => {
        const url = window.URL.createObjectURL(retorno);
        const a = document.createElement("a");
        a.href = url;
        a.download = "qrcode.png";
        document.body.appendChild(a);
        a.click();
        a.remove();
      })
      .catch(console.error);
  };
  const handleTogleOpenCadProd = () => {
    setOpenCadProd(!openCadProd);
  };
  const duplicarProduto = async (produto, grupo = null) => {
    const confirmado = await confirm({
      message: "Deseja realmente criar uma cópia deste produto?",
    });
    if (!confirmado) return;
    const service = new AuthService();

    if (!grupo) {
      grupos.forEach((g) =>
        g.produtos.forEach((p) => {
          if (p.id === produto.id) grupo = g;
        })
      );
    }

    service.post("/produto/duplicar", produto).then((prod) => {
      if (produtosBuscados?.some((p) => p.id === produto.id)) {
        setProdutosBuscados([...produtosBuscados, prod]);
      }

      grupo.produtos.push(prod);
      setGrupos([...grupos]);
      enqueueSnackbar("Produto duplicado com sucesso!", {
        variant: "success",
      });
    });
  };

  const handleOpenBusca = () => {
    setOpenBusca((prev) => !prev);
  };

  useEffect(() => {
    if (!openBusca) {
      setProdutosBuscados(null);
    }
  }, [openBusca]);

  return (
    <>
      <Template documentTitle="Cadastro do cardápio">
        <LinkMenu
          identificadores={identificadores}
          baixarQRCode={baixarQRCode}
          onCopy={onCopy}
        />
        <TitleMenu
          ativos={ativos}
          handleChangeAtivos={handleChangeAtivos}
          handleOpenBusca={handleOpenBusca}
          grupos={grupos}
          setProdutoEdit={setProdutoEdit}
          setLoading={setLoading}
          openCadProd={openCadProd}
          setOpenCadProd={setOpenCadProd}
          handleUpdateGrupo={handleUpdateGrupo}
          handleListGrupos={handleListGrupos}
          handlePauseGrupo={handlePauseGrupo}
          duplicarProduto={duplicarProduto}
          handlePauseProduto={handlePauseProduto}
        />
      </Template>
      {openCadProd && (
        <CadastroProduto
          key={produtoEdit ? produtoEdit.id : null}
          open={openCadProd}
          loading={loading}
          produto={produtoEdit}
          handleChangeProduto={handleChangeProduto}
          handleOpenCadProd={handleTogleOpenCadProd}
        />
      )}
      <DialogSearchProducts
        openBusca={openBusca}
        escolhaBusca={escolhaBusca}
        produtosBuscados={produtosBuscados}
        setSubProdutosBuscados={setSubProdutosBuscados}
        subProdutosBuscados={subProdutosBuscados}
        handleOpenBusca={handleOpenBusca}
        setEscolhaBusca={setEscolhaBusca}
        setOpenCadProd={setOpenCadProd}
        setProdutoEdit={setProdutoEdit}
        setProdutosBuscados={setProdutosBuscados}
        handlePauseProduto={handlePauseProduto}
        duplicarProduto={duplicarProduto}
      />
    </>
  );
};

export default Cardapio;
